import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control, actions } from 'react-redux-form';
import {
  Col,
  ControlLabel,
  FormGroup
} from 'react-bootstrap';
import { isEqual } from 'lodash';
import SuperSelectComponent from './SuperSelectComponent';
import ConditionalComponent from './ConditionalComponent';


export default class NodeHealthSelectorComponent extends React.Component {
  static propTypes = {
    availableNodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    availableIssues: PropTypes.arrayOf(PropTypes.string).isRequired,
    availableJobNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    nodeHealthInfo: PropTypes.object.isRequired,
    onSelectorChange: PropTypes.func.isRequired
  }

  // pulls out the Local's forms dispatcher for use
  attachDispatch = (dispatch) => this.formDispatch = dispatch;

  // succeeds whenever the given value array === ['all'], (when coming from other pages)
  checkResetModelValue = (valueArray, modelString) => {
    if (!this.formDispatch) { return; }
    if (valueArray.length === 1 && valueArray[0] === 'all') {
      this.formDispatch(actions.load(modelString, ['Select All']));
    }
  }

  render() {
    const {
      availableNodes,
      availableIssues,
      availableJobNames,
      nodeHealthInfo,
      onSelectorChange,
    } = this.props;

    const initialState = {
      nodes: nodeHealthInfo.nodes,
      issueTypeIds: nodeHealthInfo.issueTypeIds,
      jobNames: nodeHealthInfo.jobNames
    };

    return (
      <ConditionalComponent
        condition={availableIssues.length > 0 && availableNodes.length > 0}
      >
        <LocalForm
          model="info"
          getDispatch={dispatch => this.attachDispatch(dispatch)}
          initialState={initialState}
          onChange={model => onSelectorChange(model)}
        >
          <FormGroup>
            <Col md={2}>
              <ControlLabel> Nodes </ControlLabel>
              <Control.custom
                id="node-select"
                model=".nodes"
                component={SuperSelectComponent}
                className="form-control"
                style={{ marginLeft: '10px' }}
                selectAll
                focusToSelectedValue={false}
                mapProps={({ modelValue, onChange }) => {
                  this.checkResetModelValue(modelValue, 'info.nodes');
                  return {
                    options: availableNodes,
                    initialValues: modelValue,
                    onChange: (selectedOptions) => {
                      if (!isEqual(selectedOptions, modelValue)) {
                        onChange(selectedOptions);
                      }
                    },
                    getGroup: (nodeName) => {
                      const VMRegex = /-VM-/;
                      const PHRegex = /-PH-/;
                      if (VMRegex.test(nodeName)) {
                        return 'VM';
                      }
                      else if (PHRegex.test(nodeName)) {
                        return 'PH';
                      }
                      else {
                        return 'Other';
                      }
                    }
                  };
                }}
                keepOpenOnSelection
                closeOnSelectedOptionClick={false}
                multiple
                grouped
                groupSelect
                selectedCountDisplay
              />
            </Col>
            <Col md={2}>
              <ControlLabel> Issues </ControlLabel>
              <Control.custom
                id="issue-select"
                model=".issueTypeIds"
                component={SuperSelectComponent}
                className="form-control"
                style={{ marginLeft: '10px' }}
                selectAll
                focusToSelectedValue={false}
                mapProps={({ modelValue, onChange }) => {
                  this.checkResetModelValue(modelValue, 'info.issueTypeIds');
                  return {
                    options: availableIssues.sort((a, b) => {
                      const numRegex = /[^-]+-(\d+)/;
                      const aNum = a.match(numRegex)[1];
                      const bNum = numRegex.exec(b)[1];
                      return parseInt(aNum) - parseInt(bNum);
                    }),
                    initialValues: modelValue,
                    onChange: (selectedOptions) => {

                      if (!isEqual(selectedOptions, modelValue)) {
                        onChange(selectedOptions);
                      }
                    }
                  };
                }}
                keepOpenOnSelection
                closeOnSelectedOptionClick={false}
                multiple
                selectedCountDisplay
              />
            </Col>
            <Col md={2}>
              <ControlLabel> Jobs </ControlLabel>
              <Control.custom
                id="issue-select"
                model=".jobNames"
                component={SuperSelectComponent}
                className="form-control"
                style={{ marginLeft: '10px' }}
                selectAll
                focusToSelectedValue={false}
                mapProps={({ modelValue, onChange }) => {
                  this.checkResetModelValue(modelValue, 'info.jobNames');
                  return {
                    options: availableJobNames.sort(),
                    initialValues: modelValue,
                    onChange: (selectedOptions) => {
                      onChange(selectedOptions);
                    }
                  };
                }}
                keepOpenOnSelection
                closeOnSelectedOptionClick={false}
                multiple
                selectedCountDisplay
              />
            </Col>
          </FormGroup>
        </LocalForm>
      </ConditionalComponent>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/NodeHealthSelectorComponent.jsx